<div class="card-body">
    <form [formGroup]="nomineeForm" novalidate>
        <!--{{data.item}}-->
        <h5 class="text-start text-primary fw-bold ps-2 ms-1 mt-2">Nominee {{indexvalue + 1}} <span (click)="deleteNominee();deleteShare(indexvalue + 1)">
            <img src="./assets/images/delete_icon.svg" height="20" class="ps-2">
        </span></h5>
        <div class="row mx-0 mt-4">
            <div class="col-lg-6 pe-md-5 ps-md-2 px-0">
                <div class="form-floating mb-md-5 mb-4">
                    <input type="text" class="form-control text-uppercase" formControlName="NomineeFirstName" autocomplete="off" maxlength="60" id="nfname" placeholder="First Name" (input)="onInputChange($event)" (blur)="spaceValidation($event, 'NomineeFirstName')">
                    <label for="nfname">First Name <span class="text-danger">*</span></label>
                    <div *ngIf="nomineeForm.controls.NomineeFirstName.touched && nomineeForm.controls.NomineeFirstName.errors" class="ms-3 mt-2">
                        <span class="small text-danger">Please enter nominee first name</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 pe-md-5 ps-md-2 px-0">
                <div class="form-floating mb-md-5 mb-4">
                    <input type="text" class="form-control text-uppercase" formControlName="NomineeLastName" autocomplete="off" maxlength="60" id="nlname" placeholder="Last Name" (input)="onInputChange($event)" (blur)="spaceValidation($event, 'NomineeLastName')">
                    <label for="nlname">Last Name <span class="text-danger">*</span></label>
                    <div *ngIf="nomineeForm.controls.NomineeLastName.touched && nomineeForm.controls.NomineeLastName.errors" class="ms-3 mt-2">
                        <span class="small text-danger">Please enter nominee last name</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 pe-md-5 ps-md-2 px-0">
                <div class="mb-md-5 mb-4">
                    <strong class="small">Is Nominee a Minor?<span class="text-danger">*</span></strong>
                    <div class="mt-2 d-flex">
                        <div class="d-flex align-items-start">
                            <input class="ms-0 form-check-input mt-1" type="radio" value="Y"
                                [attr.name]="'isMinor' + (indexvalue + 1)" [attr.id]="'minorYes' + (indexvalue + 1)"
                                formControlName="IsMinor" (change)="minorChange()">
                            <label class="form-check-label ps-2 mb-0" [attr.for]="'minorYes' + (indexvalue + 1)"
                                style="margin-top: -4px;">Yes</label>
                        </div>
                        <div class="d-flex align-items-start ms-4">
                            <input class="ms-0 form-check-input mt-1" type="radio" value="N"
                                [attr.name]="'isMinor' + (indexvalue + 1)" [attr.id]="'minorNo' + (indexvalue + 1)"
                                formControlName="IsMinor" (change)="minorChange()">
                            <label class="form-check-label ps-2 mb-0" [attr.for]="'minorNo' + (indexvalue + 1)"
                                style="margin-top: -4px;">No</label>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Date of birth applies only to a minor nominee. -->
            <div class="col-lg-6 pe-md-5 ps-md-2 px-0" *ngIf="isMinor === 'Y'">
                <div class="input-group rounded-2 border form-floating" [ngClass]="(nomineeForm.controls.NomineeDOB.touched && nomineeForm.controls.NomineeDOB.errors) ? 'mb-md-2 mb-2':'mb-md-5 mb-4'">
                    <input class="form-control  mt-2  border-0 pe-0 ps-3 py-0" readonly formControlName="NomineeDOB" placeholder="Enter Date of Birth" ngx-mydatepicker (click)="dp.toggleCalendar();openCalendarAndDetectChanges(dp)" name="mydate"
                     [options]="options" id="ndob" #dp="ngx-mydatepicker" (dateChanged)="onDateChanged($event)" autocomplete="off"/>
                    <label for="ndob">Date of Birth<span class="text-danger">*</span></label>
                    <span class="px-3 py-2">
                        <img src="./assets/images/Calendar.svg" (click)="dp.toggleCalendar()">
                    </span>
                </div>
                <div *ngIf="nomineeForm.controls.NomineeDOB.touched && nomineeForm.controls.NomineeDOB.errors" class="ms-3 mt-2">
                    <span class="small text-danger">Please select date of birth of nominee.</span>
                </div>
            </div> 
            <div class="col-lg-6 col-md-12 ps-md-2 px-0 h-90">
                <div class="pe-md-5 mb-md-5 mb-4">
                    <div class="input-group  border form-floating pan-auto">
                        <ng-autocomplete [data]="countryList" [searchKeyword]="codeKeyword"
                            placeholder="" [itemTemplate]="itemTemplate" [(ngModel)]="countryCode" [ngModelOptions]="{standalone: true}"
                            name="source" mdbInput autocomplete="on" (inputChanged)='telcode($event)' (input)='numericOnly($event)' (closed)="checkCode()"
                            (selected)='selectCodeEvent($event)' (keydown)="restrictEnter($event)" 
                            [notFoundTemplate]="notFoundTemplate" #countryCodeInput="ngModel" id="showw">
                        </ng-autocomplete>
                        
                        <label [ngClass]="countryCode ? 'pin-top':''">Code</label>
                        <ng-template #itemTemplate let-item>
                            <a [innerHTML]="item.TeleCode"></a> <a [innerHTML]="item.Name"></a>
                        </ng-template>

                        <ng-template #notFoundTemplate let-notFound>
                            <div [innerHTML]="notFound"></div>
                        </ng-template>
                        <input type="text" (paste)="(false)" class="form-control my-1 me-2 border-top-0 border-end-0  border-bottom-0 pe-0 ps-3 py-0" autocomplete="off" (input)='numericOnly($event)' maxlength="15" id="NomineeMobile" autocomplete="off" formControlName="NomineeMobile" placeholder="Enter Mobile Number">
                        <label for="NomineeMobile" class="left">Mobile Number</label>
                    </div> 
                    <div class="ms-3 mt-2 text-danger" *ngIf="countryCodeError">
                        <span class="small">Please enter a valid country tele code.</span>
                    </div>

                    <div *ngIf="nomineeForm.controls.NomineeMobile.touched && nomineeForm.controls.NomineeMobile.errors" class="ms-3 mt-2">
                        <span class="small text-danger">Mobile number must be at least 7 digits.</span>
                    </div>
                    
                  
                </div>
            </div>
            
            <div class="col-lg-6 col-md-12 pe-md-5 ps-md-2 px-0 h-90 mb-2">
                <div class="form-floating mb-md-5 mb-4">
                    <input type="email" class="form-control " (paste)="(false)" id="email" formControlName="NomineeEmail" (input)="emailOnly($event)"  placeholder="Enter Email ID" autocomplete="off">
                    <label for="email">Email</label>
                    <div *ngIf="nomineeForm.controls.NomineeEmail.touched && nomineeForm.controls.NomineeEmail.errors" class="ms-3 mt-2">
                        <span class="small text-danger" style="font-size:15px;" *ngIf="nomineeForm.controls.NomineeEmail.errors['invalidEmailAddress']">Please enter a valid email address (e.g. john&#64;outlook.com).</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 pe-md-5 ps-md-2 px-0">
                <div class="form-floating mb-md-5 mb-4">
                    <select class="form-select" [ngClass]="nomineeForm.controls.NomineeRelationship.value ? 'optionValue' : ''" formControlName="NomineeRelationship" id="nr">
                        <option [value]="list.Value" *ngFor="let list of nomineeList; let i = index">{{list.Name}}</option>
                    </select>
                    <label [ngClass]="nomineeForm.controls.NomineeRelationship.value ? '':'form-select-label'" for="nr">Relationship with Applicant<span class="text-danger">*</span></label>
                </div>
            </div>
           
            <div class="col-lg-6 pe-md-5 ps-md-2 px-0">
                <div class="form-floating mb-md-5 mb-4">
                    <select class="form-select" formControlName="NomineeIDType" id="nId">
                        <option [value]="list.value" *ngFor="let list of nomineeIDs; let i = index">{{list.name}}</option>
                    </select>
                    <label [ngClass]="nomineeForm.controls.NomineeIDType.value ? '':'form-select-label'" for="nId">ID Proof</label>
                </div>
            </div>

            <div class="col-lg-6 pe-md-5 ps-md-2 px-0">
                <div class="form-floating mb-md-5 mb-4">
                    <input type="text" class="form-control" formControlName="NomineeProofID" autocomplete="off" maxlength="20" id="nproof" placeholder="Nominee Name" appAlphanumeric>
                    <!-- <label for="nproof">Id proof number<span class="text-danger">*</span></label> -->
                     <label for="nproof">
      {{ nomineeForm.controls.NomineeIDType?.value === 'A' 
          ? 'ID Proof Number (last 4 digits)' 
          : 'ID Proof Number' }}
    </label>
                </div>
            </div>
           
            <div class="col-lg-6 pe-md-5 ps-md-2 px-0">
                <div class="form-floating mb-md-5 mb-4">
                    <input type="text" class="form-control" autocomplete="off" maxlength="3" formControlName="NomineeShare" id="nshare" placeholder="Nomine Share" (input)="numericOnly($event);" (keyup)="emitShare(indexvalue + 1)" (paste)="(false)">
                    <label for="nshare">Nominee Share (%)</label>
                </div>
            </div>
            <div class="col-12 pe-md-5 ps-md-2 px-0 text-end" *ngIf="data.item === 1 && data.add">
                <span class="text-gradient fw-bold small border-bottom" (click)="addNominee()"><u>+ Add Nominee</u></span>
            </div>
            <div class="col-12 pe-md-5 ps-md-2 px-0 text-end" *ngIf="(indexvalue + 1 !== 3) && (data.item !== 1 && data.add)">
                <span class="text-gradient fw-bold small border-bottom" (click)="addNominee()"><u>+ Add Nominee</u></span>
            </div>
        </div>
    </form>
    <div *ngIf="guardian">
            <nri-app-guardian-info [data]="data" (guardianFormValid)="guardianData($event)" [guardianGetData]="guardianGetData"></nri-app-guardian-info>
    </div>
</div>